export const viewerIframeId: string = 'stpViewerIframe';